import axios from "axios";

export const API_URL = process.env.VUE_APP_BACKEND_URL + "/api/v1";
export const API2_URL = process.env.VUE_APP_BACKEND2_URL + "/api/pwa";
export const TAX_URL = process.env.VUE_APP_BACKEND2_URL + "/api/nav/app/tax";
// export const CORE_URL = process.env.VUE_APP_BACKEND2_URL + "/api/nav/app/tax";
export const NOTIFICATION_URL = process.env.VUE_APP_BACKEND2_URL + "/api/notification";
export const DIGEST_URL = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app/invoices-of-company";
export const CUSTOMS_URL = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app/customs";
export const RECEIPTS_URL = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app/receipt";
export const CASH_REGISTER_URL = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app/cash-register";
export const DIGEST2_URL = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app/invoice-of-company";
export const DIGEST = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app";
export const DIGEST_TOGGLE_URL = process.env.VUE_APP_BACKEND2_URL + "/api/digest/app/invoice";
//export const NOTIFICATION_URL = 'http://localhost:8570' + "/api/notification";
export const API2_PUBLIC_URL = process.env.VUE_APP_BACKEND2_URL + "/api/public";

const API_PUBLIC_URL = API_URL + "/public";
export default class Index {
  static login(loginRequest) {
    const url = API2_PUBLIC_URL + "/auth/login";
    return axios.post(url, loginRequest);
  }

  static setNewPassword(token, newPassword) {
    const url = API2_PUBLIC_URL + "/auth/reset-password";
    return axios.post(
      url,
      {
        token: token,
        password: newPassword
      }
    );
  }

  static changePassword(oldPassword, newPassword) {
    const url = API2_URL + "/user/change-password"
    return axios.post(url, {oldPassword, newPassword});
  }

  static getSumInvoicesCancel;
  static getSumInvoices(params) {
    if (Index.getSumInvoicesCancel) {
      Index.getSumInvoicesCancel.cancel("cancel");
    }
    Index.getSumInvoicesCancel = axios.CancelToken.source();

    const url = API2_URL + "/invoice/sum-invoice-incomes-by-company";
    return axios.get(url, {
      cancelToken: Index.getSumInvoicesCancel.token,
      params: params,
    });
  }

  static saveSumInvoiceFlags(body) {
    const url = API2_URL + "/invoice/save-flags";
    return axios.post(url, body);
  }
  
  static getCurrencies() {
    const url = API_URL + "/currencies";
    return axios.get(url);
  }

  static getAtalany(params) {
    const url = API_URL + "/invoice/atalany";
    return axios.get(url, { params: params });
  }

  static getAnnualSummary(params) {
    const url = API_URL + "/invoice/annual-summary";
    return axios.get(url, { params: params });
  }

  static forgotPasswordPwa(email) {
    const url = API2_PUBLIC_URL + "/auth/forgot";
    return axios.post(url, {
      email: email,
      frontend: "PWA"
    });
  }

  static register(headers) {
    const url = API_URL + "/public/register";
    return axios.post(
      url,
      {},
      {
        headers: headers,
      }
    );
  }

  static getFileDetails(resourceId) {
    const url = `${API2_URL}/resource/details-of-resource/${resourceId}`;
    return axios.get(url);
  }

  static modifyResourceTags(resourceId, tags) {
    const url = `${API2_URL}/resource/modify-tags`;
    return axios.post(url, {
      resourceId, tags
    });
  }

  static getFilesOfCompany(companyId, resourceType, page, size, textFilter) {
    const url = `${API2_URL}/resource/list-files-of-company/${companyId}`;
    return axios.get(url, {
      params: {
        resourceType,
        page,
        size,
        textFilter
      }
    });
  }

  static getInvoicesOfCompany(direction, page, size, companyId, partnerNameFilter, toBeAccountedFilter, invoiceNumberFilter, toBeDoneFilter, dateValueFilter, paidFilter) {
    const url = DIGEST_URL;
    const params = {
      companyId: companyId,
      page: page,
      size: size,
      invoiceDirection: direction,
      partnerNameFilter: partnerNameFilter,
      toBeAccountedFilter: toBeAccountedFilter,
      invoiceNumberFilter: invoiceNumberFilter,
      toBeDoneFilter: toBeDoneFilter,
      dateValueFilter: dateValueFilter,
      modifiablePaymentDateFilter: paidFilter ? 'ONLY_WITHOUT_PAYMENT_DATE' : 'ALL' // ONLY_WITH_PAYMENT_DATE || ONLY_WITHOUT_PAYMENT_DATE || ALL
    };
    return axios.post(url, params);
  }

  static getCustoms(page, size, companyId, searchTerm) {
    const url = CUSTOMS_URL + "/" + companyId;
    const params = {
      page: page,
      size: size,
      resolutionIdFilter: searchTerm
      };
    return axios.get(url, {params: params});
  }

  static toggleCustomsToBeAccounted(id, value, companyId) {
    const url = CUSTOMS_URL + "/toggle-to-be-accounted/" +companyId + "/" + id + "/" + value;
    return axios.post(url, {});
  }

  static getCustomsDetails(id, companyId){
    const url = CUSTOMS_URL + "/" + companyId + '/' + id;
    return axios.get(url);
  }

  static getInvoicesFotAttachToCustoms(companyId, filter = ''){
    const url = CUSTOMS_URL + "/invoices-for-attach/" + companyId;
    return axios.get(url, {
      params: {
        filter: filter
      }
    });
  }

  static attachInvoiceToCustoms(customsDigestId, invoiceDigestId) {
    const url = CUSTOMS_URL + "/attach-invoice"
    const params = {
      customsDigestId: customsDigestId,
      invoiceDigestId: invoiceDigestId
    };
    return axios.post(url, params);
  }

  static removeInvoiceFromCustoms(customsDigestId){
    const url = CUSTOMS_URL + "/" + customsDigestId + '/de-attach-invoice';
    return axios.delete(url);
  }

  static updateInvoiceOfCompany(invoice) {
    const url = DIGEST2_URL + "/update";
    return axios.post(url, invoice);
  }

  static getReceipts(page, size, companyId, receiptNumberFilter, paidFilter){
    const url = RECEIPTS_URL + "/get";
    const params = {
      page: page,
      size: size,
      receiptNumberFilter: receiptNumberFilter,
      paidFilter: paidFilter,
      companyId: companyId
    };
    return axios.post(url, params);
  }

  static receiptTogglePaid(receiptId){
    const url = RECEIPTS_URL + "/toggle-paid/" + receiptId;
    return axios.post(url, {});

  }

  static getCashRegisters(page, size, companyId, cashRegisterNumberFilter){
    const url = CASH_REGISTER_URL + "/get";
    const params = {
      page: page,
      size: size,
      companyId: companyId,
      cashRegisterNumberFilter: cashRegisterNumberFilter
    };
    return axios.post(url, params);
  }

  static toggleToBeAccounted(id, value) {
    const url = DIGEST_TOGGLE_URL + "/" + id + "/toggle/" + value;
    const params = {};
    return axios.post(url, {params: params});
  }
  
  static getSumInvoiceItem(id) {
    const url = API_URL + "/companies/sum-invoice-item/" + id;
    return axios.get(url);
  }

  static updateSumInvoiceItem(item) {
    const url = API_URL + "/companies/sum-invoice-item";
    return axios.post(url, item);
  }

  static getTeszorCodes() {
    const url = API_URL + "/companies/teszor-list";
    return axios.get(url);
  }

  static getTeaorCodes() {
    const url = API_URL + "/companies/teaor-list";
    return axios.get(url);
  }

  static getOvtjCodes() {
    const url = API_URL + "/companies/ovtj-list";
    return axios.get(url);
  }

  static getCurrentUser() {
    const url = API2_URL + "/user/me";
    return axios.get(url);
  }

  static getAllUser() {
    const url = API_URL + "/users/all";
    return axios.get(url);
  }

  static impersonation(id) {
    const url = API2_URL + "/user/impersonation/" + id;
    return axios.get(url);
  }

  static exitImpersonation() {
    const url = API2_URL + "/user/exit-impersonation"
    return axios.get(url);
  }

  static getEmployeeById(id) {
    const url = API2_URL + "/employee/" + id;
    return axios.get(url);
  }

  static holidaysByEmployee(id) {
    const url = API_URL + "/employee/holidays-by-employee/" + id;
    return axios.get(url);
  }

  static saveHoliday(holiday) {
    const url = API_URL + "/employee/save-holiday";
    return axios.post(url, holiday);
  }

  static deleteHoliday(id) {
    const url = API_URL + "/employee/delete-holiday/" + id;
    return axios.delete(url);
  }

  static sickLeavesByEmployee(id) {
    const url = API_URL + "/employee/sick-leave-by-employee/" + id;
    return axios.get(url);
  }

  static saveSickLeave(sickLeave) {
    const url = API_URL + "/employee/save-sick-leave";
    return axios.post(url, sickLeave);
  }

  static deleteSickLeave(id) {
    const url = API_URL + "/employee/delete-sick-leave/" + id;
    return axios.delete(url);
  }

  static saveUser(params) {
    const url = API2_URL + "/user/update";
    return axios.post(url, params);
  }

  static isCorrectPassword(params) {
    const url = API_URL + "/isCorrectPassword";
    return axios.post(url, {
      params: params,
    });
  }

  static uploadResource(params) {
    const url = API2_URL + "/resource/upload";
    const data = new FormData();
    var file = params.get("file");
    data.append("file", file, file.name);
    if (params.get("companyId")) {
      data.set("companyId", params.get("companyId"));
    }
    if (params.get("tags")) {
      data.set("tags", params.get("tags"));
    }
    if (params.get("resourceType")) {
      data.set("resourceType", params.get("resourceType"));
    }
    if (params.get("employeeId")) {
      data.set("employeeId", params.get("employeeId"));
    }
    if (params.get("id")) {
      data.set("id", params.get("id"));
    }
    return axios.post(url, data);
  }

  static getTagDates() {
    const url = API_URL + "/tags/list-date-tags";
    return axios.get(url);
  }

  static getPermanentEmployees(params) {
    const url = API_URL + "/companies/permanent-employees";
    return axios.get(url, { params: params });
  }

  static getCasualEmployees(params) {
    const url = API_URL + "/companies/casual-employees";
    return axios.get(url, { params: params });
  }

  static uploadEmployee(params, ignoreWarning) {
    let url = API2_URL + "/employee";
    if (ignoreWarning === true) {
      url += "?ignoreWarning=true";
    }
    if (params.id) {
      // edit existing employee
      return axios.put(url, params);
    } else {
      // create new employee
      return axios.post(url, params);
    }
  }

  static fileDownloadNEW(params) {
    const url = API2_URL + `/resource/${params}/download`;
    return axios.get(url, {
      responseType: "arraybuffer",
      params: { isFromPwa: true },
    });
  }

  static getMyEnabledCompanies() {
    let params = {
      enabled: true,
    };
    const url = API_URL + "/companies/user";
    return axios.get(url, { params: params });
  }

  static getTasks(params) {
    const url = API_URL + "/pwa/tasks";
    return axios.get(url, { params: params });
  }

  static getTasksWithPagination(page, size, companyId, all) {
    const params = { page: page, size: size, companyId: companyId, all: all }
    const url = NOTIFICATION_URL + "/web";
    return axios.get(url, { params: params });
  }

  static getTaskById(id) {
    const url = NOTIFICATION_URL + "/web/" + id;
    return axios.get(url);
  }

  static setTaskStatus(taskId, status) {
    const url = NOTIFICATION_URL + "/web/" + taskId + "/status/" + status;
    return axios.put(url, {});
  }

  static getCompaniesAutoComplete(params) {
    const url = API_PUBLIC_URL + "/ceginfo/auto?search=" + params.params.term;
    return axios.get(url);
  }

  static getCurrentFlatRateOfCompany(companyId) {
      const url = `${API2_URL}/company/${companyId}/current-flat-rate-type`;
      return axios.get(url);
  }

  static getCompany(id) {
    const url = `${API2_URL}/company/summary/${id}`;
    return axios.get(url);
  }

  static saveCompany(params) {
    const url = API_URL + "/mobile/company";
    return axios.post(url, params);
  }

  static updateVats(params) {
    const url =
      API_URL + "/nav/update-by-company?companyId=" + params.companyId;
    return axios.post(url);
  }

  static saveNavTechnicalUser(companyId, navUser) {
    const url = process.env.VUE_APP_BACKEND2_URL + `/api/nav/app/user/${companyId}`
    return axios.post(url, navUser);
  }

  static getNavTechnicalUser(companyId) {
    const url = process.env.VUE_APP_BACKEND2_URL + `/api/nav/app/user/${companyId}`
    return axios.get(url);
  }

  static navUserExists(companyId) {
    const url = process.env.VUE_APP_BACKEND2_URL + `/api/nav/app/user/${companyId}/exists`;
    return axios.get(url);
  }

  static getNavInvoices(companyId, direction, params) {
    const url = process.env.VUE_APP_BACKEND2_URL + `/api/nav/app/invoice/by-company/${companyId}/${direction}`;
    // const url = 'http://localhost:8591' + `/api/nav/app/invoice/by-company/${companyId}/${direction}`;
    return axios.get(url, { params });
  }

  static getSzamlazzhuKey(companyId) {
    const url = API2_URL + "/company/"+companyId+"/szamlazz-api-key";
    return axios.get(url);
  }

  static generateSzamlazzhuKey(companyId) {
    const url = API2_URL + "/company/"+companyId+"/szamlazz-api-key";
    return axios.post(url);
  }

  static getBillingoToken(companyId) {
    const url = API2_URL + `/company/${companyId}/billingo-key`;
    return axios.get(url);
  }

  static saveBillingoToken(companyId, token) {
    const url = API2_URL + `/company/billingo-key`;
    return axios.post(url, {
      companyId: companyId,
      token: token
    });
  }

  static getAvailableTags(companyId, typeFilter) {
    const url = API2_URL + `/resource/available-tags/${companyId}`;
    return axios.get(url, {
      params: { typeFilter: typeFilter },
    });
  }

  static checkResourceUpload(payload) {
    const url = API2_URL + "/resource/upload/check";
    return axios.post(url, payload);
  }

  static exitEmployee(details) {
    const url = API2_URL + "/employee/exit";
    return axios.post(url, details);
  }

  static reApplyEmployee(details) {
    const url = API2_URL + "/employee/re-apply";
    return axios.post(url, details);
  }

  static getDismissonModes() {
    const url = API_URL + "/code-store-items/type/27";
    return axios.get(url);
  }

  static getLeaveAccountings() {
    const url = API_URL + "/code-store-items/type/28";
    return axios.get(url);
  }

  static getEmployeeDiscounts(id) {
    const url = API2_URL + `/employee/${id}/discount`;
    return axios.get(url);
  }

  static getEvIdList(companyId) {
    const url = API_URL + "/companies/ev-id-list";
    return axios.get(url, { params: { companyId } });
  }

  static saveEmployeeDiscounts(data, id) {
    const url = API2_URL + `/employee/${id}/discount`;
    return axios.post(url, data);
  }

  static getFeorCodes() {
    const url = API_URL + "/employee/feor-codes";
    return axios.get(url);
  }

  static getEmploymentModes() {
    const url = API_URL + "/code-store-items/type/29";
    return axios.get(url);
  }

  static getFamilyMemberPermissions() {
    const url = API_URL + "/code-store-items/type/43";
    return axios.get(url);
  }

  static getFamilyMemberMonthlyDiscounts() {
    const url = API_URL + "/code-store-items/type/42";
    return axios.get(url);
  }

  static getDiscountOfFamilyPermissionTypes() {
    const url = API_URL + "/code-store-items/type/44";
    return axios.get(url);
  }

  static getDiscountChildTypes() {
    const url = API_URL + "/code-store-items/type/63";
    return axios.get(url);
  }

  static getWorkPosts() {
    const url = API_URL + "/code-store-items/type/30";
    return axios.get(url);
  }

  static getApplicationForms() {
    const url = API_URL + "/code-store-items/type/31";
    return axios.get(url);
  }

  static getPaymentModes() {
    const url = API_URL + "/code-store-items/type/32";
    return axios.get(url);
  }

  static getWorkTimes() {
    const url = API_URL + "/code-store-items/type/33";
    return axios.get(url);
  }

  static getAppimentTypes() {
    const url = API_URL + "/code-store-items/type/34";
    return axios.get(url);
  }

  static getPartTimeFrequencies() {
    const url = API_URL + "/code-store-items/type/35";
    return axios.get(url);
  }

  static getWorkingTimes() {
    const url = API_URL + "/code-store-items/type/36";
    return axios.get(url);
  }

  static getCircumstances() {
    const url = API_URL + "/code-store-items/type/37";
    return axios.get(url);
  }

  static getSettlementModes() {
    const url = API_URL + "/code-store-items/type/38";
    return axios.get(url);
  }

  static getJobTypes() {
    const url = API_URL + "/code-store-items/type/40";
    return axios.get(url);
  }

  static getFlatRateTypes() {
    const url = API_URL + "/code-store-items/type/41";
    return axios.get(url);
  }

  static getTaxForms() {
    const url = API_URL + "/code-store-items/type/46";
    return axios.get(url);
  }

  static getCompanyForms() {
    const url = API_URL + "/code-store-items/type/47";
    return axios.get(url);
  }

  static getTaxFrequencies() {
    const url = API_URL + "/code-store-items/type/48";
    return axios.get(url);
  }

  static getCompanyStatuses() {
    const url = API_URL + "/code-store-items/type/49";
    return axios.get(url);
  }

  static getCompanyTypes() {
    const url = API_URL + "/code-store-items/type/53";
    return axios.get(url);
  }

  static getBanks() {
    const url = API_URL + "/code-store-items/type/54";
    return axios.get(url);
  }

  static getCitizenship() {
    const url = API_URL + "/code-store-items/type/57";
    return axios.get(url);
  }

  static getRetirementTypes() {
    const url = API_URL + "/code-store-items/type/62";
    return axios.get(url);
  }

  static getStudentTypes() {
    const url = API_URL + "/code-store-items/type/64";
    return axios.get(url);
  }

  static getReceiptPadsTypes() {
    const url = API_URL + "/code-store-items/type/66";
    return axios.get(url);
  }

  static getEuSalesTypes() {
    const url = API_URL + "/code-store-items/type/67";
    return axios.get(url);
  }

  //??
  static getMaterialTaxFrees() {
    const url = API_URL + "/code-store-items/type/70";
    return axios.get(url);
  }

  static getWageTypes() {
    const url = API_URL + "/code-store-items/type/69";
    return axios.get(url);
  }

  // BE2 URLS
  static get58(companyId, year) {
    const url = API2_URL + "/58/get-58-2023"
    return axios.get(url,  { params: {
        companyId: companyId,
        year: year
      },
    })
  }

  static getPayableTaxes(companyId, year) {
    const url = API2_URL + "/tax/payable-taxes"
    return axios.get(url,  { params: {
        companyId: companyId,
        year: year
      },
    })
  }

  static getCashFlowBasedVatLimit(companyId, year) {
    const url = `${API2_URL}/company/${companyId}/cash-flow-based-vat-limit`;
    return axios.get(url, {
      params: {
        year: year
      }
    });
  }

  static getAdvancedPayment(companyId, year) {
    const url = API2_URL + "/tax/advanced-payment"
    return axios.get(url,  { params: {
        companyId: companyId,
        year: year
      },
    })
  }

  static saveAdvancedPayment(payload) {
    const url = API2_URL + "/tax/advanced-payment"
    return axios.post(url,payload)
  }
  
  static getTaxOfACompany(companyId, year, quarter, month) {
    const url = TAX_URL + "/get-tax-of-a-company"
    return axios.get(url,  { params: {
        companyId: companyId,
        year: year,
        quarter: quarter,
        month: month
      },
    })
  }

  static getOnlyIncome(companyId, year, quarter, month) {
    const url = TAX_URL + "/get-only-income"
    return axios.get(url,  { params: {
        companyId: companyId,
        year: year,
        quarter: quarter,
        month: month
      },
    })
  }

  static findUsersWithCompanies(filter) {
    const url = API2_URL + "/user/all-with-companies";
    return axios.get(url,  { params: {
        filter: filter
      },
    });
  }

  static getImpersonationDetails() {
    const url = API2_URL + "/user/impersonation-details";
    return axios.get(url);
  }

  static isEmailAvailablePublic(email) {
    const url =
      API_URL + "/public/check-email-address-availability?email=" + email;
    return axios.get(url);
  }

  static isTaxNumberRegisteredPublic(taxNumber) {
    const url = API2_PUBLIC_URL + "/register/" + encodeURIComponent(taxNumber) + "/registered";
    return axios.get(url);
  }

  static signupExternal(params) {
    const url = API_URL + "/public/signup";
    return axios.post(url, params);
  }

  static getCompaniesAutoCompletePublic(params) {
    const url = API2_PUBLIC_URL + "/register/company-search-data";
    return axios.post(url, {
      searchValue: params.params.term,
    });
  }


  static createTicket(ticket, companyId) {
    const url = API2_URL + "/missive/tickets";
    return axios.post(url + '?companyId=' + companyId, ticket);
  }

  static getTickets(page, size, companyId) {
    const url = API2_URL + "/missive/tickets" + "?companyId=" + companyId + "&page=" + page + "&size=" + size;
    return axios.get(url);
  }

  static getTicket(uuid, companyId,) {
    const url = API2_URL + "/missive/tickets/" + uuid +"?companyId=" + companyId;
    return axios.get(url);
  }

  static sendMessage(uuid, message ,companyId) {
    const url = API2_URL + "/missive/tickets/" + uuid +"/send?companyId=" + companyId;
    return axios.post(url, {message: message});
  }

  static closeTicket(uuid, companyId,) {
    const url = API2_URL + "/missive/tickets/close/" + uuid +"?companyId=" + companyId;
    return axios.post(url);
  }

  static deleteEmployee(employeeId) {
    const url = API2_URL + `/employee/${employeeId}`;
    return axios.delete(url);
  }

  static getEmployeeResources(employeeId) {
    const url = API2_URL + `/employee/${employeeId}/resources`;
    return axios.get(url);
  }

  static getResourceThumbnail(id, page = 0, forceFullSize = false) {
    const url = API2_URL + `/resource/${id}/thumbnail`;
    return axios.get(url, {
      params: {
        page: page,
        forceFullSize: forceFullSize
      }
    });
  }

  static getAttachedDpDocuments(digestId){
    const url = DIGEST + `/invoice/${digestId}/attached-dp-documents`;
    return axios.get(url);
  }

  static getKnownDocument(knownDocumentId){
    const url = DIGEST + `/knownDocument/${knownDocumentId}/`;
    return axios.get(url);
  }

  static getDocumentThumbnail(knownDocumentId, page, forceFullSize = false){
    const url = API2_URL + `/resource/thumbnail-by-known-document-id/${knownDocumentId}/thumbnail`;
    return axios.get(url, {
      params: {
        page: page,
        forceFullSize: forceFullSize
      }
    });
  }

  static aiProcessStatus(companyId){
    const url = API2_URL  + `/resource/ai-process-status/${companyId}`;
    return axios.get(url, {});
  }

  static overrideAppTagRequest(knownDocumentId, tagId){
    const url = DIGEST + `/knownDocument/${knownDocumentId}/tag`;
    return axios.post(url, {
      tagId: tagId,
    });
  }

  static listAppInvoices(params) {
    const url = API2_URL + "/invoice";
    let requestParams = {
      companyId: params.companyId,
      source: params.source,
      page: params.page,
      size: params.size,
      textFilter: params.searchTerm
    };
    if (params.direction) {
      requestParams.direction = params.direction;
    }
    if (params.freeTextFilter) {
      requestParams.freeTextFilter = params.freeTextFilter;
    }
    return axios.get(url, { params: requestParams });
  }
}
